module.exports = __webpack_public_path__ + "img/Hilltop_Grill@3x.7c8b359c.png";